import { FunctionComponent } from 'react';
import '../../../css/PublicAboutUsPage.css';

const Component07: FunctionComponent = () => {
  return (
    <div className='public-about-us-page-component-seven-container vdr-about-panel'>
      <div className='vdr-section-head vdr-about-section-head'>
        <h2 className='public-about-us-page-subtitle-text'>
          Compromiso con la innovación y el Futuro
        </h2>
        <small>I+D</small>
      </div>
      <p className='public-about-us-page-text vdr-about-lead vdr-about-quote'>
        En VisiónDERRED, nos mantenemos a la vanguardia de las tendencias tecnológicas y de la
        evolución del sector de la distribución eléctrica. A través de la investigación y el
        desarrollo continuo, buscamos anticiparnos a los desafíos que presentará el futuro, como la
        integración de recursos energéticos distribuidos y la expansión de las redes inteligentes.
        Nuestra misión es seguir ofreciendo soluciones que faciliten la transición hacia un modelo
        energético más sostenible, eficiente y accesible para todos.
      </p>
    </div>
  );
};

export default Component07;
